import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    OLPaper: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(8),
    },
    SelectInput: { "& + &": { marginTop: theme.spacing(10) } },
    checkbox: {
      color: theme.gray500,
      marginLeft: 0,
      "& span": { padding: "0 9px 0 0" },
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": { marginTop: 0 },
    },
  }),
);
